import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import useAuth from "src/hooks/useAuth";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import { Switch } from "src/@/components/ui/switch";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";

const CardActionEntrarFase = ({
  actionPhase,
  actionState,
  changeActionState,
  users
}) => {
  const { cliente } = useAuth();
  const [selectedPipe, setSelectedPipe] = useState(null);
  const [selectedPhase, setSelectedPhase] = useState(null); // Use null instead of an empty string
  const [configCrm, setConfigCrm] = useState(null);
  const [isSelectingPipe, setIsSelectingPipe] = useState(false);
  const [canais, setCanais] = useState([]);

  async function buscarListaCanais() {
    try {
      const response = await actionListaCanaisPorCliente(cliente._id);
      setCanais(response.data.data || []);
    } catch (error) {
      console.error("Erro ao buscar lista de canais:", error);
    }
  }

  let canaisFormatted = canais?.map((canal) => {
    return {
      value: canal.cliente_id || canal.clienteId,
      label: canal.nome
    }
  });

  useEffect(() => {
    buscarListaCanais();
  }, []);

  async function buscarConfigCrm(querys) {
    try {
      const result = await v2_actionConfigCrm(cliente._id, querys);
      if (result.data.data) {
        setConfigCrm(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    if (actionState?.pipelineId) {
      let querys = `?pipeline_id=${actionState?.pipelineId}`;
      buscarConfigCrm(querys);
    } else {
      buscarConfigCrm();
    }

  }, [actionState])


  return (
    <Card className="w-full">
      <CardHeader>
        <LabelFromAction>
          {actionPhase.name}
        </LabelFromAction>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">

          <RowInput
            isRequired={true}
            label="Selecione o funil"
            input={<Select
              value={actionState.pipelineId}
              onValueChange={e => {
                changeActionState({ name: "pipelineId", value: e });
                changeActionState({ name: "stageId", value: null });
                let querys = `?pipeline_id=${e}`;
                buscarConfigCrm(querys);
              }}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder={selectedPipe} />
              </SelectTrigger>
              <SelectContent>
                {configCrm?.pipelines.map((pipe) => (
                  <SelectItem key={pipe._id} value={pipe._id}>
                    {pipe.nome}
                  </SelectItem>
                ))}

              </SelectContent>
            </Select>}
          />

          {actionState?.pipelineId && (
            <div className="flex flex-col gap-2">
              <RowInput
                isRequired={true}
                label="Selecione o estágio"
                input={<Select
                  value={actionState.stageId}
                  onValueChange={e => {
                    changeActionState({ name: "stageId", value: e });
                  }}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder={selectedPhase ? selectedPhase : "Selecione..."} />
                  </SelectTrigger>
                  <SelectContent>
                    {/* Add valid phase options */}
                    {configCrm?.stages.map((stage) => (
                      <SelectItem key={stage._id} value={stage._id}>
                        {stage.nome}
                      </SelectItem>
                    ))}

                  </SelectContent>
                </Select>}
              />

              <div className="text-sm font-semibold bg-slate-100 p-2 rounded-md mt-4">
                Filtros
              </div>

              <div className="space-y-4">
                <RowInput
                  isRequired={true}
                  label="Canal"
                  info={"Canais que estão atrelados ao chat"}
                  input={
                    <MultiSelect
                      options={canaisFormatted}
                      onValueChange={(e) =>
                        changeActionState({ name: "chatChannels", value: e })
                      }
                      defaultValue={actionState.chatChannels}
                      placeholder="Selecionar canais"
                      variant="inverted"
                      animation={2}
                      maxCount={3}
                    />
                  }
                />
                <RowInput
                  label="Usuários do lead"
                  input={<MultiSelect
                    options={users}
                    onValueChange={(e) => {
                      console.log(e);
                      let event = {
                        name: "chatUsersAssign",
                        value: e
                      }
                      changeActionState(event);
                    }}
                    defaultValue={actionState?.chatUsersAssign}
                    placeholder="Selecionar usuarios"
                    variant="inverted"
                    animation={2}
                    maxCount={3}
                  />}
                />

              </div>

              <AutomationOnlyExecute
                actionState={actionState}
                changeActionState={changeActionState}
              />

            </div>


          )}



        </div>
      </CardContent>
    </Card>
  );
};

export default CardActionEntrarFase;
